import React from 'react';
import styles from './NextButton.module.scss';
import {Button} from '@material-ui/core';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';


interface INextButtonProps {
  onClick?: () => void,
  isDisabled?: boolean,
  loading?: boolean,
  label?: string;
  children?: any;
}

const NextButton = ({children, label, loading, isDisabled, onClick}: INextButtonProps) => loading ? (
  <SkeletonPlaceHolder
    className={styles.loadingField}
  />
) : (<Button
    className={`${styles.NextButton} nextButton`}
    fullWidth
    variant="contained"
    disabled={isDisabled}
    onClick={onClick}
  >
    {label || children}
  </Button>
);

NextButton.defaultProps = {
  onClick: () => {
  },
  isDisabled: false,
  isSubmitting: false,
  loading: false,
  label: '',
};
export default NextButton;
